import { render, staticRenderFns } from "./RadiologyView.vue?vue&type=template&id=4b083183"
import script from "./RadiologyView.vue?vue&type=script&lang=js"
export * from "./RadiologyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports